const ProductActionTypes = {
    SET_PRODUCT_ITEM:'SET_PRODUCT_ITEM',
}

export default ProductActionTypes